(function productSizeChartLink() {
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;

    const link = event.target.closest('.product-size-chart-link');
    if (!link) return;

    const targetId = link.getAttribute('href');
    if (!targetId || targetId.charAt(0) !== '#') return;

    const details = document.querySelector(targetId + ' details');
    if (details) details.open = true;
  });
})();
